'use strict';
angular.module('schoolLinqApp').factory('directDepositBankService', [
	'$http',
	function ($http) {
		var endpoint = '/api/prdirectdepositbank';

		function getAllDirectDepositBanks() {
			return $http.get(endpoint + '/list');
		}

		function addOrUpdateDirectDepositBank(bank) {
			return $http.put(endpoint, bank);
		}

		function deleteDirectDepositBank(bankIdToDelete) {
			return $http.post(endpoint + '/delete', bankIdToDelete);
		}

		return {
			getAllDirectDepositBanks: getAllDirectDepositBanks,
			addOrUpdateDirectDepositBank: addOrUpdateDirectDepositBank,
			deleteDirectDepositBank: deleteDirectDepositBank,
		};
	},
]);
